import {useContext} from 'react';
import {Navigate} from 'react-router-dom';
import {AppContext} from '../context/AppProvider';
interface Props {
  component: React.ComponentType;
  path?: string;
}
const PrivateRoute: React.FC<Props> = ({component: RouteComponent}) => {
  const {state} = useContext(AppContext);
  const isAuthenticated = state.isAuthenticated;
  return isAuthenticated ? <RouteComponent /> : <Navigate to="/" />;
};
export default PrivateRoute;
